<script setup lang="ts">
import { computed } from "vue";

const props = defineProps({
    data: {
        type: Object,
        default: () => ({}),
    },
});

const emit = defineEmits(["menu-click"]);

const totalPages = computed(() => Math.ceil(props.data.total / props.data.perPage));


const toPage = computed(() => {
    const currentPage = props.data.currentPage;
    const perPage = props.data.perPage;

    if (props.data.currentPage == props.data.lastPage) {
        return props.data.total;
    } else {
        return currentPage * perPage;
    }
});

const fromPage = computed(() => {
    const currentPage = props.data.currentPage;
    const perPage = props.data.perPage;
    return currentPage * perPage - (perPage - 1);
});


// const prevClick = () => {
//     const prevPage = props.data.currentPage - 1;
//     emit("menu-click", prevPage);
// };

// const nextClick = () => {
//     const nextPage = props.data.currentPage + 1;
//     emit("menu-click", nextPage);
// };

const prevClick = () => {
    if (props.data.currentPage > 1) {
        emit("menu-click", props.data.currentPage - 1);
    }
};

const nextClick = () => {
    if (props.data.currentPage < totalPages.value) {
        emit("menu-click", props.data.currentPage + 1);
    }
};

</script>

<template>
    <nav v-if="data.total > 3" role="navigation" aria-label="Pagination Navigation" class="flex items-center justify-between">
        <!-- Pagination for mobile devices -->
        <div id="mobileMenu" class="flex justify-between flex-1 hidden">
            <span
                v-if="data.currentPage <= 1"
                aria-disabled="true"
                class="cursor-not-allowed opacity-50 relative inline-flex items-center px-4 py-2 text-xs font-medium text-gray-500 bg-white border border-gray-300 leading-5 rounded-md"
            >
                Previous
            </span>
            <a
                v-else
                class="relative inline-flex items-center px-4 py-2 text-xs font-medium text-gray-700 bg-white border border-gray-300 leading-5 rounded-md hover:text-gray-500 focus:outline-none focus:ring ring-gray-300 focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
                @click="prevClick"
            >
                Previous
            </a>

            <a
                v-if="data.currentPage < data.lastPage"
                class="relative inline-flex items-center px-4 py-2 ml-3 text-xs font-medium text-gray-700 bg-white border border-gray-300 leading-5 rounded-md hover:text-gray-500 focus:outline-none focus:ring ring-gray-300 focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
                @click="nextClick"
            >
                Next
            </a>
            <span
                v-else
                aria-disabled="true"
                class="cursor-not-allowed opacity-50 relative inline-flex items-center px-4 py-2 ml-3 text-xs font-medium text-gray-500 bg-white border border-gray-300 leading-5 rounded-md"
            >
                Next
            </span>
        </div>

        <!-- Pagination -->
        <div class="flex-1 flex items-center justify-between">

            <!-- MOBILE DEVICES -->
            <div id="frontText" class="sm:hidden mr-3">
                <p class="text-xs text-gray-700 leading-5">
                    <span class="font-medium">{{ fromPage + "-" + toPage}}</span>
                    {{ $t('of') }}
                    <span class="font-bold">{{ data.total }}</span>
                    {{ $t('results') }}
                </p>
            </div>
            <!-- Text for desktop devices -->
            <div id="frontText" class="hidden sm:block sm:w-full text-right mr-3">
                <p class="text-xs text-gray-700 leading-5">
                    {{ $t('showing') }}
                    <span class="font-medium">{{ fromPage }}</span>
                    {{ $t('to') }}
                    <span class="font-medium">{{ toPage }}</span>
                    {{ $t('of') }}
                    <span class="font-bold">{{ data.total }}</span>
                    {{ $t('results') }}
                </p>
            </div>

            <div>
                <span class="relative z-0 inline-flex shadow-sm rounded-md">
                    <!-- PREVIOUS BUTTON =========================================================================================== -->
                    <button
                        @click="prevClick"
                        :disabled="data.currentPage <= 1"
                        class="disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-gray-200 bg-white relative inline-flex 
                        items-center px-2 py-1 text-sm font-medium text-gray-600 hover:bg-gray-300 border border-gray-300 shadow-sm rounded-l-md"
                    >
                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                            <path
                                fill-rule="evenodd"
                                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                                clip-rule="evenodd"
                            />
                        </svg>
                    </button>

                    <!-- NEXT BUTTON =========================================================================================== -->
                    <button
                        @click="nextClick"
                        :disabled="data.currentPage === data.lastPage"
                        class="disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-gray-200 bg-white relative inline-flex 
                        items-center px-2 py-1 text-sm font-medium text-gray-600 hover:bg-gray-300 border border-gray-300 shadow-sm rounded-r-md"
                    >
                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                            <path
                                fill-rule="evenodd"
                                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                clip-rule="evenodd"
                            />
                        </svg>
                    </button>

                </span>
            </div>
        </div>
        
    </nav>
</template>
